/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(function (algolia) {
  'use strict';

  var { disableBodyScroll, clearAllBodyScrollLocks } = window.bodyScrollLock;
  var { trapFocus, removeTrapFocus } = window.trapFocus;
  var fullScreen = window.fullScreen;

  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var connectCurrentRefinements = algolia.externals.connectors.connectCurrentRefinements;
  var connectSortBy = instantsearch.connectors.connectSortBy;

  var aa = algolia.externals.aa;

  var collectionPageEnabled = algolia.is_collection_results_page && algolia.config.instant_search_enabled_on_collection;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle = Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : collectionHandle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';

      /**
       * Override the inventory filter string if the updated filter setting is
       * enabled and the warehouse location ID is set.
       * - We should only display in stock products based on whether they are
       *   available to buy online or not.
       * - There are cases where the `inventory_quantity` is greater than 0 but
       *   the product is not available to buy online as it only has stock in
       *   the shop location but is not in a shared stock shipping policy so
       *   can't be shipped from the online storefront.
       * - The custom filtering logic that pre-filters the Algolia results is
       *   based on the following criteria:
       *   - If the `inventory_quantity` is greater than 0, it means the item is
       *     in stock, however this quantity is across all locations.
       *   - If there is stock in the warehouse location, then its always
       *     available to buy online.
       *   - If there isn't stock in the warehouse location (the OR case), then
       *     we know it must have stock in the shop locations as the
       *     `inventory_quantity` is greater than 0
       *   - We only want to display products that have stock solely in the shop
       *     location if they are in the Shared Stock shiping policy, and the
       *     `meta.syncdelta.delivery_profile_shared` is set to 1 when this is the case.
       * 
       */
      if (window.theme.settings.algolia_enable_updated_inventory_filter && window.theme.settings.algolia_warehouse_location_id) {
        const warehouseLocationFilterName = `locations_inventory.${window.theme.settings.algolia_warehouse_location_id}`;
        const warehouseLocationFilter = `${warehouseLocationFilterName} > 0`;
        stockPolicyFilter = `inventory_quantity > 0 AND (${warehouseLocationFilter} OR meta.syncdelta.delivery_profile_shared = 1)`;
      }

    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders ? algolia.collectionSortOrders : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function (k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function (uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function (routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var focussedId = null;

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets ? algolia.collectionHiddenFacets : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets ? algolia.collectionShownFacets : algolia.shownFacets,
      list: collectionPageEnabled && algolia.collectionFacets ? algolia.collectionFacets : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled && algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      searchClient: algoliasearch(algolia.config.app_id, algolia.config.search_api_key),
      indexName: algolia.config.index_prefix + 'products',
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: function (searchFunctionHelper) {
        if (document.activeElement) {
          focussedId = document.activeElement.id;
        }

        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        searchFunctionHelper.setQueryParameter('highlightPreTag', '<span class="ais-highlight">');
        searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter('filters', searchFilters.join(' AND '));
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPageEnabled) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [collectionRulesContextValue.toString()]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    storeName: algolia.storeName,
    templates: {
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate('instant_search'),
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats'),
      statsBottom: algolia.getTemplate('instant_search_stats_bottom'),
      style: algolia.compileTemplate('instant_search.css'),
      showPreviousText: algolia.getTemplate('instant_search_show_previous_text'),
      showMoreText: algolia.getTemplate('instant_search_show_more_text'),
      currentRefinedValues: algolia.compileTemplate('instant_search_current_refined_values'),
      currentRefinedValuesItem: algolia.compileTemplate('instant_search_current_refined_values_item'),
      sortBy: algolia.getTemplate('instant_search_facet_sort_by'),
      sortByItem: algolia.compileTemplate('instant_search_facet_sort_by_item'),
    },
  };

  instant.search.client.addAlgoliaAgent('Shopify Integration');

  algolia.instantsearch = instant;

  if (instant.poweredBy) {
    // eslint-disable-next-line no-console
    console.log('Algolia: Instant-Search');
  }

  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }

  // Bind helpers
  var helpers = algolia.assign({}, algolia.helpers, algolia.translation_helpers);
  Object.keys(helpers).forEach(function (name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    })
  );

  if (collectionPageEnabled) {
    if (document.querySelectorAll(algolia.config.collection_css_selector).length === 0) {
      throw new Error(
        'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
      );
    }
  } else if (document.querySelectorAll(algolia.config.results_selector).length === 0) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  instant.$results = document.querySelector(instant.selector);

  instant.$results.innerHTML = algolia.render(instant.templates.page, {
    facets: instant.facets.shown,
    storeName: instant.storeName,
    translations: algolia.translations,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function () {
    readjust();
  });

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      clickAnalytics: true,
      facetingAfterDistinct: false, // force update again
    }),
  ]);

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
      autofocus: true
    }),
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Stats bottom
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-bottom-container',
      templates: {
        text: instant.templates.statsBottom,
      },
    }),
  ]);

  // Create the sort by render function
  const renderSortBy = (renderOptions, isFirstRender) => {
    const { options, currentRefinement, refine, widgetParams, hasNoResults } = renderOptions;

    widgetParams.container.innerHTML = instant.templates.sortBy;

    const root = widgetParams.container.firstElementChild;

    root.innerHTML = `
      ${options
        .map((option, index) => {
          return algolia.render(instant.templates.sortByItem, {
            index: index,
            label: option.label === 'Relevance' ? 'Default' : option.label,
            value: option.value,
            hasNoResults: hasNoResults,
            isSelected: option.value === currentRefinement,
          });
        })
        .join('')}
    `;

    var inputEls = widgetParams.container.querySelectorAll('input');

    inputEls.forEach((inputEl) => {
      inputEl.addEventListener('change', (event) => {
        refine(event.target.value);
      });
    });
  };

  // Create the custom sort by widget
  const customSortBy = connectSortBy(renderSortBy);

  // Instantiate the custom sort by widget
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      customSortBy({
        container: document.querySelector('.ais-sort-orders-container'),
        items: instant.sortOrders,
      }),
    ]);
  }

  // Hidden facets
  var list = instant.facets.hidden.map(function (facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function () {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function () {},
    },
  ]);

  // Create the render function
  var createDataAttributes = function (refinement) {
    return Object.keys(refinement)
      .map(function (key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function (item) {
    var facet = instant.facets.list.find(function (f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function (refinement) {
        var label = refinement.label;

        if (refinement.attribute == 'price_range') {
          var price_range_min = refinement.label.split(':')[0];
          var price_range_max = refinement.label.split(':')[1];

          label = `
            ${algolia.formatMoney(price_range_min * 100)} -
            ${algolia.formatMoney(price_range_max * 100)}
          `;
        }

        return algolia.render(instant.templates.currentRefinedValuesItem, {
          dataAttributes: createDataAttributes(refinement),
          label: label,
        });
      })
      .join('');
  };

  var renderCurrentRefinements = function (renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML = algolia.render(instant.templates.currentRefinedValues, {
      items: items.map(renderListItem).join(''),
    });

    Array.prototype.slice
      .call(widgetParams.container.querySelectorAll('.ais-current-refined-values--link'))
      .forEach(function (element) {
        element.addEventListener('click', function (event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function (acc, key) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          }, {});

          refine(item);
        });
      });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function (resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function (facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(function (facet) {
      return facet.name === facetName;
    });
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(function (facet) {
      return facet.name === facetName;
    });

    return isFacetValueAvailable || isDisjunctiveFacetValueAvailable || isHierarchicalFacetValueAvailable;
  };

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function (widget) {
    var facetWithPanel = panel({
      hidden: function (options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName =
          '.ais-facet-' + encodeURIComponent(widget.params.attribute).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });

  // Hits
  instant.search.addWidgets([
    algolia.externals.widgets.infiniteHits({
      container: '.ais-hits-container',
      showPrevious: true,
      templates: {
        empty: instant.templates.empty,
        item: instant.templates.product,
        showPreviousText: instant.templates.showPreviousText,
        showMoreText: instant.templates.showMoreText,
      },
      transformItems: function (products) {
        return products.map(function (product) {
          var can_order =
            product.inventory_management !== 'shopify' ||
            product.inventory_policy === 'continue' ||
            product.variants_inventory_count > 0;

          var label = null;

          if (!can_order) {
            label = window.theme.locales.product.sold_out;

            if (product.meta.back_in_stock && product.meta.back_in_stock.enabled) {
              label = window.theme.locales.product.bis_notify;
            }
          }

          if (product.meta.availability && product.meta.availability.status) {
            switch (product.meta.availability.status) {
              case 'Enquire now':
                label = window.theme.locales.product.enquire_now;
                break;
              case 'Notify when launched':
                if (!can_order) {
                  label = window.theme.locales.product.launch_notify;
                }
                break;
            }
          }

          return algolia.assign({}, product, {
            _distinct: instant.distinct,
            can_order: can_order,
            translations: algolia.translations,
            queryID: product.__queryID,
            productPosition: product.__position,
            index: instant.search.mainIndex.getIndexName(),
            label: label,
            geData: typeof product.meta == 'object' ?
                product.meta.globale_attributes || {} :
                {}
            ,
          });
        });
      },
    }),
  ]);

  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function () {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function (e) {
          var el = e.target;
          var hit;
          do {
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;

          // Construct the link we should redirect to
          var link = '';

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          if (collectionPageEnabled && collectionHandle) {
            link = '/collections/' + collectionHandle;
          }

          // Add the product handle to the link
          link = link + '/products/' + productHandle;

          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }

          if (algolia.config.analytics_enabled) {
            var clickData = {
              index: hit.dataset.algoliaIndex,
              eventName: 'click',
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
              positions: [Number(hit.dataset.algoliaPosition)],
            };

            // Send the click event
            aa.clickedObjectIDsAfterSearch(clickData);
            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
            // algolia.saveForConversionTracking(clickData);
          }
          window.location.href = link;
        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function () {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function (e) {
          var el = e.target;
          var cartButton;
          do {
            if (el.matches('.ais-hit--cart-button')) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) {
            return;
          }

          e.stopPropagation();
          var $this = cartButton;
          var formId = $this.dataset.formId;

          if (formId) {
            document.getElementById(formId).submit();
          }
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function (opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function (e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function (facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function (e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  // Manipulate hit product cards post-render
  instant.search.on('render', () => {
    var hits = Array.from(document.querySelectorAll('.ais-hit')).filter(
      (hit) => !hit.hasAttribute('data-product-card-is-injected')
    );

    if (!hits.length) return;

    var q = hits.map((hit) => `id:"${hit.getAttribute('data-id')}"`).join(' OR ');

    var url = `/search?section_id=search-data&type=product&q=${q}`;

    fetch(url)
      .then((res) => res.text())
      .then((resHTML) => {
        var parser = new DOMParser();
        var parserDocument = parser.parseFromString(resHTML, 'text/html');

        var resProductCardDataAll = parserDocument.querySelectorAll('[data-product-card-data]');

        resProductCardDataAll.forEach((resProductCard) => {
          var hit = document.querySelector(`.ais-hit[data-id="${resProductCard.id}"]`);
          var resProductCardContent = resProductCard.content;

          if (!hit) return;

          injectSizes(hit, resProductCardContent);

          injectPicture(hit, resProductCardContent);

          hit.setAttribute('data-product-card-is-injected', true);
        });
        document.querySelectorAll('.ais-hit:not(.has-price)').forEach(element => {
          element.querySelector('.ais-hit--price').textContent = 'Please Enquire';
          element.classList.add('pointer-events-none');
        })
      })
      .catch((err) => {
        console.log(err);
      });

    function injectSizes(hit, resProductCard) {
      var hitProductCardSizesContainer = hit.querySelector('p.ais-hit--price');
      if (!hitProductCardSizesContainer) return;

      var productCardSizesContainer = resProductCard.querySelector('[data-product-card-sizes]');
      if (!productCardSizesContainer) return;

      hitProductCardSizesContainer.innerHTML = productCardSizesContainer.innerHTML;

      hit.classList.add('has-price');
      hit.classList.remove('pointer-events-none');
    }

    function injectPicture(hit, resProductCard) {
      var hitProductCardPicture = hit.querySelector('.ais-hit--picture');
      if (!hitProductCardPicture) return;

      var productCardPicture = resProductCard.querySelector('[data-product-card-pictures]')
      if (!productCardPicture) return;

      var hitProductCardPictureContainer = hitProductCardPicture.parentNode;

      hitProductCardPictureContainer.innerHTML = productCardPicture.querySelector('div').innerHTML;
    }
  });

  // Manipulate facets post-render
  document.addEventListener('alpine:init', () => {
    var helper = instant.search.helper;

    var hasRendered = false;

    var facetsEl = document.querySelector('.ais-facets');

    var facetsScrollEl = document.querySelector('[data-facets-scroll]');

    var facetsTrapEl = document.querySelector('[data-facets-trap]');

    var facetsButtonElSelector = '[data-facets-button]';
    var facetsButtonEl = document.querySelector(facetsButtonElSelector);

    var facetDetailsElAll = document.querySelectorAll('[data-facet-details]');

    instant.search.on('render', () => {
      // Maintain focussed element
      if (focussedId) {
        document.getElementById(focussedId).focus();
      }

      // Active facets refinement count
      var activeFacetsRefinementCountEl = document.querySelector('[data-active-facets-refinement-count]');

      if (activeFacetsRefinementCountEl) {
        var facetsRefinements = helper.state.facetsRefinements;
        var disjunctiveFacetsRefinements = helper.state.disjunctiveFacetsRefinements;

        var activeFacetsRefinementCount = Object.keys(facetsRefinements).reduce((acc, key) => {
          acc += facetsRefinements[key].length;
          return acc;
        }, 0);

        activeFacetsRefinementCount = Object.keys(disjunctiveFacetsRefinements).reduce((acc, key) => {
          acc += disjunctiveFacetsRefinements[key].length;
          return acc;
        }, activeFacetsRefinementCount);

        if (activeFacetsRefinementCount > 0) {
          activeFacetsRefinementCountEl.innerHTML = `(${activeFacetsRefinementCount})`;
        } else {
          activeFacetsRefinementCountEl.innerHTML = '';
        }
      }

      // Active facet labels container
      var activeFacetLabelsContainerAllEl = document.querySelector('[data-active-facet-labels-all-container]');

      var activeFacetLabelsContainerAllHTML = helper.state.facets.map((facetName) => {
        return `
            <div class="contents" data-active-facet-labels-container="${facetName}">
            </div>
          `;
      });

      activeFacetLabelsContainerAllHTML = activeFacetLabelsContainerAllHTML.concat(helper.state.disjunctiveFacets.map((facetName) => {
        return `
            <div class="contents" data-active-facet-labels-container="${facetName}">
            </div>
          `;
      }));

      activeFacetLabelsContainerAllHTML = activeFacetLabelsContainerAllHTML.join('');

      activeFacetLabelsContainerAllEl.innerHTML = algolia.render(instant.templates.currentRefinedValues, {
        items: activeFacetLabelsContainerAllHTML,
      });

      // Active facet labels container
      var activeFacetLabelsContainerAttr = 'data-active-facet-labels-container';
      var activeFacetLabelsContainerSelector = `[${activeFacetLabelsContainerAttr}]`;
      var activeFacetLabelsContainerElAll = document.querySelectorAll(activeFacetLabelsContainerSelector);

      activeFacetLabelsContainerElAll.forEach((activeFacetLabelsContainerEl) => {
        var facetName = activeFacetLabelsContainerEl.getAttribute(activeFacetLabelsContainerAttr);

        var defaultLabel = activeFacetLabelsContainerEl.getAttribute('data-default-label');

        var facetsRefinement = helper.state.disjunctiveFacets.includes(facetName) ?
            helper.state.disjunctiveFacetsRefinements[facetName] :
            helper.state.facetsRefinements[facetName];

        activeFacetLabelsContainerEl.innerHTML = defaultLabel;

        if (
          facetName == 'price_range' &&
          helper.state.disjunctiveFacetsRefinements.price_range &&
          helper.state.disjunctiveFacetsRefinements.price_range.length
        ) {
          activeFacetLabelsContainerEl.innerHTML = helper.state.disjunctiveFacetsRefinements.price_range
            .map((label) => {
              var price_range_min = label.split(':')[0];
              var price_range_max = label.split(':')[1];

              return algolia.render(instant.templates.currentRefinedValuesItem, {
                dataAttributes: 'data-facets-clear="price_range"',
                label: `
                  ${algolia.formatMoney(price_range_min * 100)} -
                  ${algolia.formatMoney(price_range_max * 100)}
                `,
              });
            })
            .join('');
        }

        if (
          facetName == 'price' &&
          helper.state.numericRefinements.price &&
          Object.keys(helper.state.numericRefinements.price).length
        ) {
          var rangeEl = document.querySelector('[data-ais-range-slider]');

          var minEl = rangeEl.querySelector('[data-gte-input]');
          var maxEl = rangeEl.querySelector('[data-lte-input]');

          var min = +minEl.min;
          var max = +maxEl.max;

          var currentMin =
            (helper.state.numericRefinements.price['>='] && helper.state.numericRefinements.price['>='][0]) || min;

          var currentMax =
            (helper.state.numericRefinements.price['<='] && helper.state.numericRefinements.price['<='][0]) || max;

          if (currentMin != min || currentMax != max) {
            activeFacetLabelsContainerEl.innerHTML = algolia.render(instant.templates.currentRefinedValuesItem, {
              dataAttributes: 'data-facets-clear="price"',
              label: `
                ${algolia.formatMoney(currentMin)} -
                ${algolia.formatMoney(currentMax)}
              `,
            });
          }
        }

        if (facetName == 'sort-by' && helper.state.index) {
          var sortOrder = instant.sortOrders.find((_sortOrder) => _sortOrder.value == helper.state.index);

          if (sortOrder) {
            activeFacetLabelsContainerEl.innerHTML = algolia.render(instant.templates.currentRefinedValuesItem, {
              dataAttributes: 'data-facets-clear="sort-by"',
              label: sortOrder.label,
            });
          }
        }

        if (!facetName || !facetsRefinement || !facetsRefinement.length) return;

        activeFacetLabelsContainerEl.innerHTML = facetsRefinement
          .map((label) => {
            return algolia.render(instant.templates.currentRefinedValuesItem, {
              dataAttributes: `data-facets-clear="${facetName}" data-value="${label}"`,
              label: label,
            });
          })
          .join('');
      });

      if (hasRendered) {
        return;
      }

      // Only run on first render

      // Set facet details element open state
      if (facetDetailsElAll.length) {
        facetDetailsElAll.forEach((facetDetailsEl) => {
          if (window.Alpine.store('screens').active.includes('sm')) {
            facetDetailsEl.open = true;
          }
        });
      }

      // Toggle facets open
      document.addEventListener('click', function (event) {
        if (!event.target.closest(facetsButtonElSelector)) return;

        if (facetsEl.classList.contains('ais-facets__shown')) {
          facetsEl.classList.remove('ais-facets__shown');

          if (window.Alpine.store('screens').active.includes('sm')) {
            clearAllBodyScrollLocks();
          } else {
            fullScreen.deactivate();
          }

          removeTrapFocus(facetsButtonEl);
        } else {
          facetsEl.classList.add('ais-facets__shown');

          if (window.Alpine.store('screens').active.includes('sm')) {
            disableBodyScroll(facetsScrollEl);
          } else {
            fullScreen.activate();
          }

          trapFocus(facetsTrapEl);
        }
      });

      // Close facets when overlay clicked
      if (facetsEl) {
        facetsEl.addEventListener('click', (event) => {
          if (!event.target.matches('.ais-facets')) return;

          facetsEl.classList.remove('ais-facets__shown');

          if (window.Alpine.store('screens').active.includes('sm')) {
            clearAllBodyScrollLocks();
          } else {
            fullScreen.deactivate();
          }

          removeTrapFocus(facetsButtonEl);
        });
      }

      // Close facets with escape key pressed
      if (facetsEl) {
        document.addEventListener('keyup', (event) => {
          if (event.key == 'Escape' && facetsEl.classList.contains('ais-facets__shown')) {
            facetsEl.classList.remove('ais-facets__shown');

            if (window.Alpine.store('screens').active.includes('sm')) {
              clearAllBodyScrollLocks();
            } else {
              fullScreen.deactivate();
            }

            removeTrapFocus(facetsButtonEl);
          }
        });
      }

      // Clear facets
      var facetsClearElAttr = 'data-facets-clear';
      var facetsClearElSelector = `[${facetsClearElAttr}]`;
      var facetsClearElAll = document.querySelectorAll(facetsClearElSelector);

      document.addEventListener('click', function (event) {
        var facetsClearEl = event.target.closest(facetsClearElSelector);

        if (!facetsClearEl) return;

        var facetName = facetsClearEl.getAttribute(facetsClearElAttr);

        var facetValue = facetsClearEl.getAttribute('data-value');

        if (facetName) {
          if (facetValue) {
            helper.state.disjunctiveFacets.includes(facetName) ?
              helper.removeDisjunctiveFacetRefinement(facetName, facetValue) :
              helper.removeFacetRefinement(facetName, facetValue);
          } else {
            helper.clearRefinements(facetName);
          }
        } else {
          instant.facets.list.forEach(function (facet) {
            helper.clearRefinements(facet.name);
          });
        }

        helper.search();
      });

      // Facet columns rules
      var facetColumnsAttr = 'data-facet-columns';
      var facetColumnsSelector = `[${facetColumnsAttr}]`;
      var facetColumnsElAll = document.querySelectorAll(facetColumnsSelector);

      facetColumnsElAll.forEach((facetColumnsEl) => {
        var facetTitle = facetColumnsEl.getAttribute(facetColumnsAttr);
        var facetTitleHandle = facetTitle.toLowerCase();

        var filtersColumnRules = window.theme.settings.filters_column_rules;

        if (!filtersColumnRules || !filtersColumnRules.length) return;

        filtersColumnRules.forEach((rule) => {
          var ruleTitleHandle = rule.split(':')[0].trim().toLowerCase();

          var ruleColumns = rule.split(':')[1].trim();

          if (ruleTitleHandle == facetTitleHandle) {
            facetColumnsEl.style.setProperty('--columns', ruleColumns);
          }
        });
      });

      // Auto open facets for testing
      // facetsButtonEl.click();

      hasRendered = true;
    });
  });

  // Main
  instant.search.start();

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);
